import { render } from "./ModalNewBet.vue?vue&type=template&id=f1a69c9e&scoped=true"
import script from "./ModalNewBet.vue?vue&type=script&lang=js"
export * from "./ModalNewBet.vue?vue&type=script&lang=js"

import "./ModalNewBet.vue?vue&type=style&index=0&id=f1a69c9e&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f1a69c9e"]])

export default __exports__